import { SearchFieldValue, SearchType } from 'main/components/SearchBar/types';

export const searchTypeOptions = [
    {
        value: SearchType.simple,
        label: 'Lucene search'
    },
    {
        value: SearchType.product,
        label: 'Search by product'
    },
    {
        value: SearchType.elastic,
        label: 'Elastic search'
    }
] as const;

export const optionByValue = searchTypeOptions.reduce(
    (acc, option) => ({ ...acc, [option.value]: option }),
    {} as Record<SearchType, typeof searchTypeOptions[number]>
);

export const defaultSearchBarValue: SearchFieldValue = {
    type: SearchType.simple,
    query: '',
    software: '',
    version: ''
};

export const emptyArray = [];

export const defaultSimpleSearchSuggestions = [
    'type',
    'published',
    'lastseen',
    'modified',
    'title',
    'bounty',
    'cpe',
    'order',
    'cvss.score'
];
